import { UniversityCreate } from './UniversityCreate';
import { UniversityEdit } from './UniversityEdit';
import { UniversityList } from './UniversityList';
import { UniversityShow } from './UniversityShow';

export const create = UniversityCreate;
export const list = UniversityList;
export const edit = UniversityEdit;
export const show = UniversityShow;
